import {
    TRecipientInfo,
    TRecipientPlasticInfo,
} from '@/src/modules/build-a-card/inputs/types'

type TQuantityProps = {
    quantity: number
    setQuantity: Function
    setListOfRecipients: Function
    minValue?: number
    maxValue?: number
    isPlastic?: boolean
    defaultRecipient?: TRecipientInfo | TRecipientPlasticInfo
}

export async function decrement({
    quantity,
    setQuantity,
    minValue,
    setListOfRecipients,
}: TQuantityProps) {
    if (!minValue || quantity > minValue) {
        await setListOfRecipients(
            (previous: TRecipientInfo[] | TRecipientPlasticInfo[]) => {
                const newList = [...previous]
                newList.pop()
                return [...newList]
            }
        )
        await setQuantity(quantity - 1)
    }
}

export async function increment({
    quantity,
    setQuantity,
    maxValue,
    setListOfRecipients,
    defaultRecipient,
    isPlastic = false,
}: TQuantityProps) {
    if (!maxValue || quantity < maxValue) {
        let recipient = isPlastic
            ? {
                  recipientName: '',
                  recipientMessage: '',
                  senderName: '',
                  recipientHasError: false,
                  recipientErrorMessages: [],
              }
            : {
                  recipientName: '',
                  recipientEmail: '',
                  recipientPhone: '',
                  recipientHasError: false,
                  recipientErrorMessages: [],
              }

        // if we're in the plastic flow & we're passing in a default recipient
        // use the recipient's info for all gifts when adding --> ex: apply to all
        if (!!defaultRecipient && isPlastic) {
            recipient = {
                ...defaultRecipient,
                recipientHasError: false,
                recipientErrorMessages: [],
            }
        }

        await setListOfRecipients(
            (previous: TRecipientInfo[] | TRecipientPlasticInfo[]) => {
                const newList = [...previous]
                newList.push(recipient)
                return [...newList]
            }
        )
        await setQuantity(quantity + 1)
    }
}
